import cx from 'classnames';
import { Fragment, ReactNode } from 'react';

type FlowTitleProps = {
  cols: ReactNode[];
  isTitleContainsImage?: boolean;
  fullWidth?: boolean;
  imageContainer?: ReactNode;
  orientation?: string;
  flowTitleClassName?: string;
  flowSectionClassName?: string;
  id?: string;
  extraContent?: ReactNode[];
  isSold?: boolean;
  isReservated?: boolean;
  inCart?: boolean;
};

const FlowTitleSEO = ({
  cols,
  isTitleContainsImage = false,
  imageContainer,
  orientation = 'flex-col',
  fullWidth = false,
  flowTitleClassName,
  flowSectionClassName,
  id,
  extraContent,
  isSold = false,
  isReservated = false,
  inCart = false,
}: FlowTitleProps) => {
  return (
    <section
      id={id}
      className={cx(
        'py-8 px-4 lg:py-16',
        isSold
          ? 'bg-red-10'
          : isReservated
          ? 'bg-yellow-10'
          : inCart
          ? 'bg-green-10'
          : 'bg-neutral-5',
        flowTitleClassName
      )}
    >
      <section
        className={cx(
          'container lg:px-4 w-full mx-auto',
          'flex items-center lg:gap-12',
          isTitleContainsImage ? 'max-lg:flex-col flex-row' : 'flex-col',
          flowSectionClassName
        )}
      >
        <section
          className={cx(
            fullWidth ? 'w-full' : 'basis-7/12',
            'flex gap-4 lg:gap-6',
            isTitleContainsImage ? 'lg:items-left' : 'lg:items-center',
            orientation ? orientation : 'flex-col',
            'text-xl'
          )}
        >
          {cols
            .filter((col) => !!col)
            .map((col, idx) => (
              <Fragment key={idx}>{col}</Fragment>
            ))}
        </section>
        {extraContent &&
          extraContent
            .filter((col) => !!col)
            .map((col, idx) => <Fragment key={idx}>{col}</Fragment>)}
        {isTitleContainsImage && imageContainer}
      </section>
    </section>
  );
};

export default FlowTitleSEO;
